import styled, { css } from 'foundations-theming-specialty/utils';
import { TableIcon } from 'foundations-assets/icons/components/TableIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { NotificationPopupIcon } from 'foundations-assets/icons/components/NotificationPopupIcon';
import { TicketListingView } from '../containers/TicketListings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Track = styled.button.withConfig({
  displayName: "ViewToggleSwitch__Track"
})(["padding:0;margin:0;background:#e5e5e5;border:none;border-radius:", ";display:flex;height:", ";position:relative;"], ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.space[800]);
const Switch = styled.div.withConfig({
  displayName: "ViewToggleSwitch__Switch"
})(["width:", ";height:", ";background:", ";border-radius:", ";box-shadow:", ";position:absolute;top:0;left:0;transition:transform 0.2s ease-in-out;transform:translateX(0);", ""], ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.color['icon-core-on-fill-default'], ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.boxShadow['100'], ({
  $enabled
}) => $enabled && css(["transform:translateX(", ");"], ({
  theme
}) => theme.space[800]));
const Option = styled.div.withConfig({
  displayName: "ViewToggleSwitch__Option"
})(["width:", ";height:", ";border-radius:", ";display:flex;align-items:center;justify-content:center;position:relative;z-index:1;"], ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.borderRadius[100]);
export function ViewToggleSwitch({
  view,
  onChange
}) {
  const title = view !== TicketListingView.GRID ? I18n.text('customer-portal-app.activateCardView') : I18n.text('customer-portal-app.activateTableView');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    children: /*#__PURE__*/_jsxs(Track, {
      type: "button",
      "data-test-id": "view-toggle-switch",
      "aria-label": title,
      "aria-pressed": view === TicketListingView.GRID,
      onClick: () => onChange(view === TicketListingView.GRID ? TicketListingView.TABLE : TicketListingView.GRID),
      children: [/*#__PURE__*/_jsx(Switch, {
        $enabled: view === TicketListingView.GRID
      }), /*#__PURE__*/_jsx(Option, {
        $enabled: view === TicketListingView.GRID,
        children: /*#__PURE__*/_jsx(TableIcon, {
          color: view !== TicketListingView.GRID ? 'icon-core-default' : 'icon-core-subtle'
        })
      }), /*#__PURE__*/_jsx(Option, {
        $enabled: view === TicketListingView.TABLE,
        children: /*#__PURE__*/_jsx(NotificationPopupIcon, {
          color: view !== TicketListingView.TABLE ? 'icon-core-default' : 'icon-core-subtle'
        })
      })]
    })
  });
}